import styled, { css } from "styled-components"

interface RadioGroupFlexLayout {
  type: "flex"
  gap?: string
  direction?: "horizontal" | "vertical"
}
interface RadioGroupGridLayout {
  type: "grid"
  gap?: string
  direction?: "horizontal" | "vertical"
  columns?: string
  rows?: string
  areas?: string
}
export type RadioGroupLayout = RadioGroupFlexLayout | RadioGroupGridLayout

const flexLayout = (layout: RadioGroupFlexLayout) => css`
  display: inline-flex;
  flex-direction: ${layout.direction === "horizontal" ? "row" : "column"};
  gap: ${layout.gap};

  .--radio-group-checkbox {
    justify-content: start;
    align-items: center;

    /* TODO remove this when flex gap support is widespread */
    &:not(:last-of-type) {
      margin: ${
        layout.direction === "horizontal"
          ? `0 ${layout.gap} 0 0`
          : `0 0 ${layout.gap} 0`
      };
    }
  }
`
const gridLayout = (layout: RadioGroupGridLayout) => css`
  display: inline-grid;
  grid-auto-flow: ${layout.direction === "horizontal" ? "column" : "row"};
  gap: ${layout.gap};

  ${layout.columns && `grid-template-columns: ${layout.columns};`};
  ${layout.rows && `grid-template-rows: ${layout.rows};`};
  ${layout.areas && `grid-template-areas: ${layout.areas};`};

  & > * {
    justify-self: start;
    align-self: start;
  }
`

function getLayout(layout: RadioGroupLayout) {
  switch (layout.type) {
    case "flex":
      return flexLayout(layout)
    case "grid":
      return gridLayout(layout)
  }
}

interface WrapperProps {
  layout: RadioGroupLayout
}
export const Wrapper = styled.div<WrapperProps>`
  ${(props) => getLayout(props.layout)}
`

interface RadioWrapperProps {
  gridArea?: string
  justifySelf?: string
  alignSelf?: string
}
export const RadioWrapper = styled.div<RadioWrapperProps>`
  ${(props) => props.gridArea && `grid-area: ${props.gridArea};`}
  ${(props) => props.justifySelf && `justify-self: ${props.justifySelf};`}
  ${(props) => props.alignSelf && `align-self: ${props.alignSelf};`}
`
